import React from "react";
import { Phone, ExternalLink } from "lucide-react";
import { BOOKING_URL, PHONE_TEL, PHONE_DISPLAY } from "./Header";

export function MobileBottomBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-forest-900/95 backdrop-blur-md border-t border-forest-700/50 shadow-lift"
      style={{ minHeight: "calc(var(--mobile-sticky-h) + env(safe-area-inset-bottom, 0px))" }}
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-2 gap-2 p-2">
        <a
          href={`tel:${PHONE_TEL}`}
          className="flex items-center justify-center gap-2 py-3 rounded-full border border-cream/40 text-cream text-sm font-medium"
          data-testid="mobile-call-cta"
          aria-label={`Call Now — ${PHONE_DISPLAY}`}
        >
          <Phone size={16} aria-hidden="true" /> Call Now
        </a>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-3 rounded-full bg-brass text-cream text-sm font-medium"
          data-testid="mobile-book-cta"
        >
          Book Now <ExternalLink size={14} />
        </a>
      </div>
    </div>
  );
}
